import { render, staticRenderFns } from "./loadingDetailSearch.vue?vue&type=template&id=65f03861&"
import script from "./loadingDetailSearch.vue?vue&type=script&lang=js&"
export * from "./loadingDetailSearch.vue?vue&type=script&lang=js&"
import style0 from "./loadingDetailSearch.vue?vue&type=style&index=0&id=65f03861&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports